import React from 'react';
import styled from 'styled-components';

// Components //
import View from 'components/View';

const Root = styled(View)`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${ ({ active, theme }) => active ? theme.color.text : 'transparent' };
  border: ${ ({ active, theme }) => active ? 'none' : `1px solid rgba(0, 0, 0, 0.2)` };
`;

const Dot = props => {
  return (
    <Root {...props} />
  );
}

export default Dot;
